// Voice API Test Script
// Run window.testVoiceAPI() in browser console

window.testVoiceAPI = async function() {
  console.log('🧪 Testing Voice API Integration...');
  
  try {
    // Test 1: Check authentication
    console.log('\n1️⃣ Testing Authentication...');
    const { fetchAuthSession } = await import('aws-amplify/auth');
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString() || session.tokens?.accessToken?.toString();
    
    if (!token) {
      console.error('❌ No auth token found');
      return;
    }
    
    console.log('✅ Auth token found:', token.substring(0, 50) + '...');
    
    // Test 2: Test direct API call
    console.log('\n2️⃣ Testing Direct API Call...');
    const response = await fetch('https://oauth.remote-assistant.ai/api/voices/available', {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    console.log('Response status:', response.status);
    console.log('Response headers:', Object.fromEntries(response.headers.entries()));
    
    if (response.ok) {
      const data = await response.json();
      console.log('✅ API Response:', data);
    } else {
      const errorText = await response.text();
      console.error('❌ API Error:', errorText);
    }
    
    // Test 3: Test OPTIONS preflight
    console.log('\n3️⃣ Testing CORS Preflight...');
    const optionsResponse = await fetch('https://oauth.remote-assistant.ai/api/voices/available', {
      method: 'OPTIONS',
      headers: {
        'Access-Control-Request-Method': 'GET',
        'Access-Control-Request-Headers': 'Authorization,Content-Type'
      }
    });
    
    console.log('OPTIONS status:', optionsResponse.status);
    console.log('OPTIONS headers:', Object.fromEntries(optionsResponse.headers.entries()));
    
    // Test 4: Test configService method
    console.log('\n4️⃣ Testing ConfigService Method...');
    try {
      const configService = (await import('./services/configService.js')).default;
      const result = await configService.getAvailableVoices();
      console.log('✅ ConfigService result:', result);
    } catch (error) {
      console.error('❌ ConfigService error:', error);
    }
    
  } catch (error) {
    console.error('❌ Test failed:', error);
  }
};

window.testVoiceEndpoints = async function() {
  console.log('🔍 Testing All Voice Endpoints...');
  
  const endpoints = [
    { method: 'GET', url: '/api/voices/available', name: 'Voice Discovery' },
    { method: 'POST', url: '/api/voices/preview', name: 'Voice Preview', body: { provider: 'cartesia', voice_config: { voice_id: 'test' }, text: 'test' } },
    { method: 'PUT', url: '/api/config/voice-settings', name: 'Voice Settings', body: { phone_number: '+16044239724', selected_voice: { provider: 'cartesia' } } }
  ];
  
  try {
    const { fetchAuthSession } = await import('aws-amplify/auth');
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString();
    
    for (const endpoint of endpoints) {
      console.log(`\n🧪 Testing ${endpoint.name}...`);
      
      const options = {
        method: endpoint.method,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      };
      
      if (endpoint.body) {
        options.body = JSON.stringify(endpoint.body);
      }
      
      const response = await fetch(`https://oauth.remote-assistant.ai${endpoint.url}`, options);
      console.log(`${endpoint.name} status:`, response.status);
      
      if (response.ok) {
        const data = await response.json();
        console.log(`✅ ${endpoint.name} success:`, data);
      } else {
        const error = await response.text();
        console.error(`❌ ${endpoint.name} error:`, error);
      }
    }
  } catch (error) {
    console.error('❌ Endpoint test failed:', error);
  }
};

console.log('🧪 Voice API test functions loaded. Run:');
console.log('  window.testVoiceAPI() - Full API test');
console.log('  window.testVoiceEndpoints() - Test all endpoints');